document.addEventListener('click', function (event) {
    const source = event.target.closest('.value-takeover');

    if (source !== null) {
        if (source.dataset.takeoverTarget !== null) {
            const target = document.querySelector(source.dataset.takeoverTarget);

            target.value = source.dataset.takeoverValue;
            target.dispatchEvent(new Event('blur'));
        }
    }
});
